// src/modules/IntegratedMessaging/hooks/useTeams.ts
import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { TeamsApiAdapter } from '../adapters/TeamsApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const adapter = new TeamsApiAdapter(httpClient);

export interface Team {
  id: number;
  name: string;
}

export const useTeams = () => {
  return useQuery<Team[], Error>({
    queryKey: ['teams'],
    queryFn: () => adapter.getTeams(),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });
};
